import React from 'react';
import styled from '@emotion/styled';

type SpinnerProps = {
  className?: string;
  'data-e2e'?: string;
};

/**
 * The inline spinner, for a table cell or a list row — not `Loader`, which is a 150px Lottie animation
 * with a 50px floor.
 *
 * The design system specs no spinner, so this extrapolates from `loader.tsx`'s Suspense fallback per D1 —
 * same tokens, same animation, at one inline size.
 */
export const Spinner: React.FunctionComponent<SpinnerProps> = ({ className, 'data-e2e': dataE2e }) => (
  <TokenSpinner className={className} data-e2e={dataE2e} role="status" />
);

const TokenSpinner = styled.div`
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: var(--border-width-sm) solid var(--icon-secondary);
  border-top-color: var(--icon-action);
  animation: spinner-spin 0.8s linear infinite;

  @keyframes spinner-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export default Spinner;
